import { Apis } from '../../lib/Apis';

export const useReviews = () => {
    const getReviews = async (status, setReviewData, offset = 0, limit = 9) => {
        try {
            const params = {
                status,
                offset,
                limit
            };
            const response = await Apis.getReviews(params);
            setReviewData(response.data);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const acceptReviews = async (body) => {
        try {
            const response = await Apis.acceptReviews(body);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    return { getReviews, acceptReviews };
};
